import { useContext, useEffect, useState } from "react";
import "./css/FormacionDesarrollo.css";
import CheckPermission from "../../helpers/Administradores/Permissions";
import AddIcon from "../../assets/svg/icono_agregar_blue.svg";

import CreateTrainingPlan from "./modals/CreateTrainingPlan";
import { createTrainingPlanModal } from "../../context/FormacionDesarollo/TrainingPlansActions";
import TrainingPlansContext from "../../context/FormacionDesarollo/TrainingPlansContext";
import { useQuery } from "@apollo/client";

import { Grid } from "@material-ui/core";
import SearcherCard from "./components/SearcherCard";
import TrainingPlanCard from "./TrainingPlanCard";
import "./css/TrainingPlan.css";
import { GET_ALL_TRAININGPLANS } from "../../Querys/querys";
import UpdateTrainingPlan from "./modals/UpdateTrainingPlan";
export interface TrainingPlans {
  id: number;
  nameTrainingPlan: string;
  startTrainingPlan: string;
  endTrainingPlan: string;
  active: string;
  status: string;
  dateAdd: string;
  idCurso: number;
  descriptionTrainingPlan: string;
  totalCursos: number;
  expectedProgress: number;
  colaboradores: number;
  isEditable: boolean;
}
interface TrainingPlansQuery {
  GET_ALL_TRAININGPLANS: TrainingPlans[];
}

const TrainingPlans = () => {
  const { state, dispatch } = useContext(TrainingPlansContext);

  const [trainingPlansFilter, setTrainingPlansFilter] = useState<
    TrainingPlans[]
  >([]);
  const [trainingPlans, setTrainingPlans] = useState<TrainingPlans[]>([]);
  const [trainingPlan, setTrainingPlan] = useState<TrainingPlans[]>([]);
  const {
    data: trainingPlansInfo,
    loading,
    startPolling,
    stopPolling,
  } = useQuery<TrainingPlansQuery>(GET_ALL_TRAININGPLANS);

  useEffect(() => {
    if (trainingPlansInfo && trainingPlansInfo.GET_ALL_TRAININGPLANS) {
      setTrainingPlans(trainingPlansInfo.GET_ALL_TRAININGPLANS);
      setTrainingPlansFilter(trainingPlansInfo.GET_ALL_TRAININGPLANS);
      setTrainingPlan(trainingPlansInfo.GET_ALL_TRAININGPLANS);
    }
  }, [trainingPlansInfo]);

  // useEffect(() => {
  //   if (trainingPlansFilter.length > 0) {
  //     const orderFilter = [...trainingPlansFilter];
  //     orderFilter.sort((a: any, b: any) => {
  //       return b.id - a.id;
  //     });
  //     setTrainingPlans(orderFilter);
  //   } else {
  //     setTrainingPlans(trainingPlansFilter);
  //   }
  // }, [trainingPlansFilter]);

  useEffect(() => {
    startPolling(5000);
    console.log(trainingPlans);
    console.log(trainingPlansFilter);
    return () => {
      stopPolling();
    };
  }, [startPolling, stopPolling]);

  return (
    <>
      <div className="conteinerBtnsCourses">
        {CheckPermission("FormacionDesarrollo.TrainingPlans.Crear") && (
          <div>
            <button
              id="addCourse"
              className="btnNuevoCurso"
              onClick={() => createTrainingPlanModal(true, dispatch)}
            >
              <div className="alineacionBoton">
                <img src={AddIcon} alt="Agregar Plan de Capacitacion" />
                <div className="nombreCurso">
                  <b>
                    <span>Crear plan de capacitaci&oacute;n</span>
                  </b>
                </div>
              </div>
            </button>
          </div>
        )}
      </div>
      <CreateTrainingPlan />
      {state._id !== "" && <UpdateTrainingPlan />}
      {loading === true ? (
        <div className="c_contenedorPrincipal">
          <div className="contenedorLoadingPrincipal">
            <div className="loadingPrincipal"></div>
          </div>
        </div>
      ) : (
        <div className="c_contenedorPrincipal">
          <Grid container className="screenBtns">
            <Grid className="findTrainingPlan">
              <SearcherCard
                initState={trainingPlans}
                setState={setTrainingPlansFilter}
                stateInitial={trainingPlan}
                label="Buscar plan de capacitación"
                fields={["nameTrainingPlan"]}
                width={400}
              />
            </Grid>
          </Grid>
          <Grid container className="cardsTrainingPlan">
            {trainingPlansFilter.length >= 1 ? (
              <Grid container spacing={2}>
                {trainingPlansFilter?.map((trainingPlan: TrainingPlans) => (
                  <Grid item key={trainingPlan.id}>
                    <TrainingPlanCard trainingPlan={trainingPlan} />
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Grid container justify="flex-start" className="msjNotFound">
                <span className="msjNotFound2">
                  Aún no tienes planes de capacitación registrados
                </span>
              </Grid>
            )}
          </Grid>
        </div>
      )}
    </>
  );
};

export default TrainingPlans;
